import Vue, { FunctionalComponentOptions, CreateElement, RenderContext } from 'vue';

export const ButtonProgress = <FunctionalComponentOptions>{
    functional: true,
    name: 'button-progress',
    props: {
        progress: {
            type: Boolean,
            default: false
        }
    },
    render(h, ctx) {
        return (
            h('button', { 
                class: [ctx.data.staticClass, 'button-progress'], 
                on: clickHandler(ctx),
                attrs: { disabled: ctx.data.attrs.disabled }
            }, buttonContent(h, ctx))
        )
    }
}

function clickHandler(ctx: RenderContext) {
    if (ctx.data.on && ctx.data.on.click) {
        return { click: ctx.data.on.click }
    }
    return null;
}

function buttonContent(h: CreateElement, ctx: RenderContext) {
    if (ctx.props.progress) {
        return [ h('div', { class: 'button-progress-spinner' }) ];
    }
    return ctx.slots().default;
}